import React from "react";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import img1 from "../../../assets/jobEmailModal/answer_img1.png";
import img2 from "../../../assets/jobEmailModal/answer_img2.png";
import img3 from "../../../assets/jobEmailModal/answer_img3.png";
import Button from "../../../components/Button";

const ModalStyled = styled(Modal)`
  .ant-modal-body {
    padding: 20px 40px;
  }

  b {
    color: #343a40;
  }
  .ant-modal-title {
    display: flex;
    justify-content: center;
    font-size: 20px;
  }

  img {
    margin-top: 15px;
  }
`;

const JobEmailModal = ({ visible = true, onClose }) => {
  const { t } = useTranslation(["global", "opportunity", "form"]);

  return (
    <ModalStyled
      width={600}
      visible={visible}
      destroyOnClose={true}
      onCancel={() => onClose()}
      keyboard={false}
      title={<b>{t("opportunity:publishing.jobPostEmail.modal.title")}</b>}
      footer={[
        <Button key="close" type="primary" onClick={onClose}>
          {t("global:back")}
        </Button>
      ]}
    >
      <b>{t("opportunity:publishing.jobPostEmail.modal.question1")}</b>
      <p>{t("opportunity:publishing.jobPostEmail.modal.answer1")}</p>
      <br />
      <b>{t("opportunity:publishing.jobPostEmail.modal.question2")}</b>
      <img src={img1} alt="Img" />
      <br />
      <br />
      <b>{t("opportunity:publishing.jobPostEmail.modal.question3")}</b>
      <img src={img2} alt="Img" />
      <br />
      <br />
      <b>{t("opportunity:publishing.jobPostEmail.modal.question4")}</b>
      <img src={img3} alt="Img" />
    </ModalStyled>
  );
};

export default JobEmailModal;
